import ProductsView from "./ProductsView";
export default ProductsView;